"use client";
import { Box, Card, Typography } from "@repo/ui";
import Image from "next/image";

const companies = [
  { src: "/images/companies/tcs.png", alt: "tcs" },
  { src: "/images/companies/wipro.png", alt: "wipro" },
  { src: "/images/companies/ibm.png", alt: "ibm" },
  { src: "/images/companies/facebook.png", alt: "facebook" },
  { src: "/images/companies/infosys.png", alt: "infosys" },
  { src: "/images/companies/bosch.png", alt: "bosch" },
  { src: "/images/companies/flipkart.png", alt: "flipkart" },
  { src: "/images/companies/mobily.png", alt: "mobily" },
];

type CompanyLogoCardProps = {
  className?: string;
};

const CompanyLogoCard = ({ className }: CompanyLogoCardProps) => {
  return (
    <Card
      className={`!shadow-lg w-full  mt-6 sm:mt-4 ${className ? className : ""}`}
    >
      <Box className="px-8 py-5">
        <Typography variant="body2">
          Trusted by <b>2000+</b> companies
        </Typography>
        <Box
          flex
          mt="md"
          alignItems="center"
          className="gap-4 sm:gap-6 lg:gap-8 flex-wrap justify-center sm:justify-between"
        >
          {companies.map((company, index) => (
            <div
              key={index}
              className="relative w-16 h-8 sm:w-20  lg:w-24  flex-shrink-0"
            >
              <Image
                src={company.src}
                alt={company.alt}
                quality={25}
                priority
                fill
                className="object-contain object-center drop-shadow-lg"
                sizes="(max-width: 640px) 64px, (max-width: 1024px) 80px, 96px"
              />
            </div>
          ))}
        </Box>
      </Box>
    </Card>
  );
};

export default CompanyLogoCard;
